import { environment } from "src/environments/environment"
import { CORE_URL } from "./core/domain/core-api-token"
import { EX_API_URL } from "./core/domain/ex-api-token"
import { AI_URL } from "./core/domain/ai-url-token"
import { CLOUD_FUNCTIONS_URL } from "./core/domain/cloud-functions-url-token"
import { TRANSLATION_TOKEN, TranslationToken } from "./core/domain/translation-token"

export const provideUrls = () => [
    {
        provide: CORE_URL,
        useValue: environment.coreApi
    },
    {
        provide: EX_API_URL,
        useValue: environment.exApi
    },
    {
        provide: AI_URL,
        useValue: environment.aiApi
    },
    {
        provide: CLOUD_FUNCTIONS_URL,
        useValue: environment.cloudfunctionsUrl
    },
    {
        provide: TRANSLATION_TOKEN,
        useValue: {
            url: environment.translationAPI,
            useJsonFiles: environment.jsonTranslation
        } as TranslationToken
    }
]
